import axios from '../utils/request'

const MiscellaneousDataApi = () => {
  return axios.get('GetMiscellaneousData', {
  })
}

const CustomerListApi = (SalespersonID, Customer, CurrentPage, pageSize) => {
  return axios.get('GetNonStandardCustomerList?SalespersonID=' + SalespersonID + '&Customer=' + Customer + '&CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, {
  })
}

const NonStandardProductinformlistApi = (ProductID, ProductName, Classification, CurrentPage, pageSize) => {
  return axios.get('GetNonStandardProductinformlist?ProductID=' + ProductID + '&Product_Name=' + ProductName + '&Classification=' + Classification + '&CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, {
  })
}

const ChangeMiscellaneous = (loginInfo) => {
  return axios.post('ChangeMiscellaneous', {
    ...loginInfo
  })
}

const GetNonStandardTableApi = (loginInfo) => {
  return axios.post('GetNonStandardTableData', {
    ...loginInfo
  })
}

const ChangeNonStandardData = (loginInfo) => {
  return axios.post('ChangeNonStandardData', {
    ...loginInfo
  })
}

export {
  MiscellaneousDataApi,
  ChangeMiscellaneous,
  GetNonStandardTableApi,
  CustomerListApi,
  NonStandardProductinformlistApi,
  ChangeNonStandardData
}
